<template>
  <div class="coupon-detail-modal-mask" v-if="visible">
    <div class="coupon-detail-modal">
      <img :src="CloseIcon" alt class="coupon-detail-close" @click="handleClose" />
      <div class="coupon-detail-modal-header">优惠券使用说明</div>
      <div class="coupon-detail-modal-body">
        <div class="coupon-body-title">
          <span class="coupon-body-title-text">Q1：目前有几种优惠形式？</span>
        </div>
        <div class="coupon-body-explain">目前支持代金券、折扣券两种优惠形式</div>
        <div class="coupon-body-title">
          <span class="coupon-body-title-text">Q2：优惠券怎么获得？如何使用？使用规则？</span>
        </div>
        <div
          class="coupon-body-explain"
        >
        <p>1) 优惠券是由机构发放的一种优惠形式，具体优惠可查看优惠券的使用限制</p>
        <p>2）获得优惠券后，您可以在【我的】—【优惠券】进行查看</p>
        <p>3）若使用优惠券，可将指定商品加入购物车，您可以在【订单填写】页选择【可用优惠券】，我们将自动减掉指定商品的优惠金额 </p>
        <p> * 同一订单中仅可使用1张优惠券，不可叠加使用</p>
        <p> * 取消订单只退实付金额不退已核销的券</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/images/close.png";
import CouponUseRangeEnum from "@/enum/CouponUseRangeEnum";

export default {
  props: {
    visible: {
        type: Boolean, 
        default: false
    }
  },

  data() {
    return {
      CloseIcon
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="less">
.coupon-detail-modal-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1111;
  .coupon-detail-modal {
    width: 5.4rem;
    height: 6.4rem;
    border-radius: 0.24rem;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 2.2rem;
    position: relative;
    padding-top: 0.32rem;
    .coupon-detail-close {
      width: 0.24rem;
      height: 0.24rem;
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
    }
    .coupon-detail-modal-header {
      font-size: 0.34rem;
      color: #333;
      font-weight: 500;
      height: 0.34rem;
      line-height: 0.34rem;
      text-align: center;
      margin-bottom: 0.32rem;
    }
    .coupon-detail-modal-body {
      height: 5rem;
      overflow: auto;
      text-align: left;
      padding: 0 0.32rem;
      .coupon-body-title {
        font-size: 0.3rem;
        color: #333;
        display: flex;
        align-items: center;
        margin-bottom: 0.16rem;
        .coupon-body-title-circle {
          width: 0.12rem;
          height: 0.12rem;
          display: inline-block;
          border-radius: 50%;
          background: #666;
          margin-right: 0.08rem;
        }
        .coupon-body-title-text {
        }
      }
      .coupon-body-explain {
        color: #999;
        margin-bottom: 0.32rem;
        word-break: break-all;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/module/benefits/CouponDescModal.vue